export enum BlogStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  UNPUBLISHED = 'unpublished',
}

export enum ContentBlockType {
  TEXT = 'text',
  IMAGE = 'image',
  VIDEO = 'video',
}

export interface ContentBlock {
  type: ContentBlockType;
  content: string;
  order: number;
  caption?: string;
  alt?: string;
  videoThumbnail?: string;
}

export interface Blog {
  _id: string;
  title: string;
  slug: string;
  excerpt?: string;
  featuredImage?: string;
  contentBlocks: ContentBlock[];
  status: BlogStatus;
  priority: number;
  tags: string[];
  metaTitle?: string;
  metaDescription?: string;
  author: {
    _id: string;
    firstName: string;
    lastName: string;
    email?: string;
  };
  publishedAt?: string;
  views: number;
  allowComments: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateBlogDto {
  title: string;
  slug?: string;
  excerpt?: string;
  featuredImage?: string;
  contentBlocks?: Omit<ContentBlock, '_id'>[];
  status?: BlogStatus;
  priority?: number;
  tags?: string[];
  metaTitle?: string;
  metaDescription?: string;
  allowComments?: boolean;
}

export interface UpdateBlogDto extends Partial<CreateBlogDto> {}

export interface BlogListResponse {
  blogs: Blog[];
  total: number;
  totalPages: number;
}

export interface BlogStats {
  total: number;
  published: number;
  draft: number;
  unpublished: number;
  totalViews: number;
} 